import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";
import UsersAddForm from "./UsersAddForm";

import { Container } from "@styles/grid";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const UsersAdd = () => (
  <Layout pageTitle="Add User">
    <Container>
      <Content>
        <UsersAddForm />
      </Content>
    </Container>
  </Layout>
);

export default UsersAdd;
